// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

const ALLOWED_LINK_PROTOCOLS = ['http:', 'https:', 'ftp:', 'ftps:'];

/**
 * Creates a safe, viewable URL string from user input by validating the
 * protocol. URLs without a protocol are treated as HTTPS URLs.
 */
export function createViewableURLString(url: string): string | null {
  try {
    const parsedURL = new URL(url);
    if (ALLOWED_LINK_PROTOCOLS.includes(parsedURL.protocol)) {
      return parsedURL.toString();
    }
    return null;
  } catch {
    try {
      const parsedURL = new URL(`https://${url}`);
      if (ALLOWED_LINK_PROTOCOLS.includes(parsedURL.protocol)) {
        return parsedURL.toString();
      }
    } catch {
      return null;
    }
  }

  return null;
}
